import {Injectable, NgZone} from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  openSignInDialog$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private zone: NgZone,
    private toaster: ToastrService
  ) {}

  public openSignIn(data?: any) {
    this.openSignInDialog$.next(data || { open: true });
  }
}
